import React from 'react';

/**
 * PostCard Component
 * Example component for displaying Ghost post data
 */
function PostCard({ title, excerpt, author, date, imageUrl }) {
    const cardStyle = {
        border: '1px solid #e1e4e8',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'box-shadow 0.3s ease'
    };

    const titleStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '10px',
        color: '#15171A'
    };

    const excerptStyle = {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#738a94',
        marginBottom: '15px'
    };

    const metaStyle = {
        fontSize: '14px',
        color: '#738a94',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    };

    return (
        <div 
            style={cardStyle}
            onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)'}
            onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'}
        >
            {imageUrl && (
                <img 
                    src={imageUrl} 
                    alt={title}
                    style={{ 
                        width: '100%', 
                        height: '200px', 
                        objectFit: 'cover', 
                        borderRadius: '4px',
                        marginBottom: '15px'
                    }}
                />
            )}
            <h3 style={titleStyle}>{title}</h3>
            <p style={excerptStyle}>{excerpt}</p>
            <div style={metaStyle}>
                <span>{author}</span>
                <span>{new Date(date).toLocaleDateString()}</span>
            </div>
        </div>
    );
}

export default PostCard;
